/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getUsersQueryPageDefault = 1;export const getUsersQueryPageSizeDefault = 25;export const getUsersQuerySortDescendingDefault = false;

export const getUsersQueryParams = zod.object({
  "page": zod.number().default(getUsersQueryPageDefault),
  "pageSize": zod.number().default(getUsersQueryPageSizeDefault),
  "search": zod.string().optional(),
  "sortBy": zod.string().optional(),
  "sortDescending": zod.boolean().optional(),
  "isActive": zod.boolean().optional()
})

export const getUsersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "primaryEmail": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "isActive": zod.boolean(),
  "isPrimaryEmailVerified": zod.boolean(),
  "lastSeenDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({})
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

